export enum FacilityRentalType { DURATION = 'duration', OVERNIGHT = 'overnight'}

export enum ReservationClass { AGENT = 'agent', MANAGER = 'manager'}
